module.exports = __webpack_public_path__ + "8178fcf8c97c53dfbf9753bf94d0c91f.jpg";